export default __webpack_public_path__ + "static/media/linktree.9ef0edb4.png";